import { render, staticRenderFns } from "./coursedetailspage.vue?vue&type=template&id=31823b79&scoped=true&"
import script from "./coursedetailspage.vue?vue&type=script&lang=js&"
export * from "./coursedetailspage.vue?vue&type=script&lang=js&"
import style0 from "./coursedetailspage.vue?vue&type=style&index=0&id=31823b79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31823b79",
  null
  
)

export default component.exports